import React from 'react';
import LoadingModal from '../Modal/LoadingModal';
export default function Loading(props) {
  if (props.error) {
    return <div>Error!</div>;
  } else if (props.pastDelay) {
    return <div>Loading...</div>;
  } else if (props.isLoading) {
    return (
      <LoadingModal isOpen={props.isLoading} />
    );
  } else {
    return null;
  }
}



// WEBPACK FOOTER //
// ./src/components/Loading/Loading.js